// packages/content/src/tuning/push.ts (M1-T18, spec §10.4) — default quiet hours in device minutes of day (22:00–08:00)
import type { TuningBank } from '../schema/tuning';
export default { quietStart: 1320, quietEnd: 480, maxFails: 5, ttlSeconds: 86_400 } as const satisfies TuningBank;
